import React, { Component } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { CommmonService } from "app/_services/CommonService/CommonService";
import { SetPermission } from "app/Components/SetPermission/Permissions";
import { FcApprove } from "react-icons/fc";

// CommmonService
class ApproveReject extends Component {
  constructor(props) {
    super(props);
  }

  approve(e, projectId, id) {
    e.preventDefault();

    confirmAlert({
      title: "Approve",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let obj = {
              id: id,
              tableName: this.props.tableName,
              status: 1,
            };
            let response = await CommmonService.approveReject(obj);

            if (response && response.status) {
              this.props.setData(1, id);
            }
          },
        },
        {
          label: "No",
          onClick: () => console.log("test"),
        },
      ],
    });
  }

  reject(e, projectId, id) {
    e.preventDefault();

    confirmAlert({
      title: "Reject",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let obj = {
              id: id,
              tableName: this.props.tableName,
              status: 2,
            };
            let response = await CommmonService.approveReject(obj);

            if (response && response.status) {
              this.props.setData(2, id);
            }
          },
        },
        {
          label: "No",
          onClick: () => console.log("test"),
        },
      ],
    });
  }

  render() {
    let { projectId, rowId, status, permission, global } = this.props;

    return (
      <React.Fragment>
        {status == 0 && (
          <>
            {this.props.permission ? (
              <SetPermission
                permission={
                  parseInt(projectId) == 0
                    ? "global_defaultConfiguration_approve"
                    : permission
                }
                global={parseInt(projectId) == 0 || global}
                data={
                  <React.Fragment>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Approve</Tooltip>}
                    >
                      <a
                        href="#"
                        className="icons text-success"
                        onClick={(e) => this.approve(e, projectId, rowId)}
                      >
                        <FaCheck />
                      </a>
                    </OverlayTrigger>

                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Reject</Tooltip>}
                    >
                      <a
                        // href="#"
                        className="icons text-danger"
                        onClick={(e) => this.reject(e, projectId, rowId)}
                      >
                        <FaTimes />
                      </a>
                    </OverlayTrigger>
                  </React.Fragment>
                }
              ></SetPermission>
            ) : (
              <React.Fragment>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Approve</Tooltip>}
                >
                  <a
                    href="#"
                    className="icons text-success"
                    onClick={(e) => this.approve(e, projectId, rowId)}
                  >
                    <FaCheck />
                  </a>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Reject</Tooltip>}
                >
                  <a
                    // href="#"
                    className="icons text-danger pointer"
                    onClick={(e) => this.reject(e, projectId, rowId)}
                  >
                    <FaTimes />
                  </a>
                </OverlayTrigger>
              </React.Fragment>
            )}
          </>
        )}
        {status == 1 && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Approved</Tooltip>}
          >
            <a
              // href="#"
              className="icons text-success"
              // onClick={e => this.approve(e, projectId, rowId)}
            >
              <FcApprove size="26" />
            </a>
          </OverlayTrigger>
        )}
        {status == 2 && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Rejected</Tooltip>}
          >
            <a
              // href="#"
              className="icons text-danger"
              style={{ width: "25px" }}
              // onClick={e => this.reject(e, projectId, rowId)}
            >
              <img src="/assets/images/disapproved.svg" />
            </a>
          </OverlayTrigger>
        )}
      </React.Fragment>
    );
  }
}

export default ApproveReject;
